<app-login-card>
  <div class="row form-row">
    <div class="col-md-12">
      <h1 class="text-center" data-test-id="oauth-error-heading">{{ texts.headingKey | translate }}</h1>
    </div>
  </div>
  <div class="row form-row">
    <div class="col-12">
      <ds-banner [state]="texts.bannerState" data-test-id="oauth-error-message">
        <div ds-banner-body>{{ texts.messageKey | translate }}</div>
      </ds-banner>
    </div>
  </div>
  @if (errorCode) {
    <div class="row form-row">
      <div class="col-12">
        <small class="text-muted" data-test-id="oauth-error-code">{{ 'oauth_error_code_label' | translate: errorCode }}</small>
      </div>
    </div>
  }
</app-login-card>
